import {
  Home as HomeIcon,
  AttachFile as AttachFileIcon,
  Dashboard as DashboardIcon,
} from '@material-ui/icons';
import { ChatIconWithBadge } from 'screens/ChatScreen/components';
import { ru } from 'locale';

const tabs = [
  { label: ru.ankets, value: '/', icon: DashboardIcon },
  { label: ru.main, value: 'main', icon: HomeIcon },
  { label: ru.chat, value: 'chat', icon: ChatIconWithBadge },
  { label: ru.attachments, value: 'attachments', icon: AttachFileIcon },
];

export default tabs;
